import { gql } from '@apollo/client';
import { WEBSITE_ADMIN_CONTENT_FIELDS } from './queries';

/*
 * 新建、保存、发布、定时四个请求携带正文 JSON，会命中全局 XSS 过滤器，
 * 其操作名 CreateWebsiteContent、SaveWebsiteContentDraft、PublishWebsiteContent、ScheduleWebsiteContent
 * 在 XSS 白名单中（common_config `security.xss_filter.whitelist_operations`），不能改名；单测锁定。
 */

export const CREATE_WEBSITE_CONTENT = gql`
  mutation CreateWebsiteContent($input: WebsiteContentDraftInput!) {
    createWebsiteContent(input: $input) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const SAVE_WEBSITE_CONTENT_DRAFT = gql`
  mutation SaveWebsiteContentDraft($id: Long!, $input: WebsiteContentDraftInput!, $baseDraftHash: String) {
    saveWebsiteContentDraft(id: $id, input: $input, baseDraftHash: $baseDraftHash) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const PUBLISH_WEBSITE_CONTENT = gql`
  mutation PublishWebsiteContent($id: Long!, $input: WebsiteContentDraftInput!, $baseDraftHash: String) {
    publishWebsiteContent(id: $id, input: $input, baseDraftHash: $baseDraftHash) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const SCHEDULE_WEBSITE_CONTENT = gql`
  mutation ScheduleWebsiteContent(
    $id: Long!
    $input: WebsiteContentDraftInput!
    $scheduledAt: String!
    $baseDraftHash: String
  ) {
    scheduleWebsiteContent(id: $id, input: $input, scheduledAt: $scheduledAt, baseDraftHash: $baseDraftHash) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const CANCEL_WEBSITE_CONTENT_SCHEDULE = gql`
  mutation CancelWebsiteContentSchedule($id: Long!) {
    cancelWebsiteContentSchedule(id: $id) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const TAKE_WEBSITE_CONTENT_OFFLINE = gql`
  mutation TakeWebsiteContentOffline($id: Long!) {
    takeWebsiteContentOffline(id: $id) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const DELETE_WEBSITE_CONTENT = gql`
  mutation DeleteWebsiteContent($id: Long!) {
    deleteWebsiteContent(id: $id) {
      ...WebsiteAdminContentFields
    }
  }
  ${WEBSITE_ADMIN_CONTENT_FIELDS}
`;

export const BATCH_TAKE_WEBSITE_CONTENT_OFFLINE = gql`
  mutation BatchTakeWebsiteContentOffline($ids: [Long!]!) {
    batchTakeWebsiteContentOffline(ids: $ids) {
      succeededIds
      skipped {
        contentId
        reason
        status
      }
    }
  }
`;

export const BATCH_DELETE_WEBSITE_CONTENT = gql`
  mutation BatchDeleteWebsiteContent($ids: [Long!]!) {
    batchDeleteWebsiteContent(ids: $ids) {
      succeededIds
      skipped {
        contentId
        reason
        status
      }
    }
  }
`;

export const CREATE_WEBSITE_CONTENT_PREVIEW_LINK = gql`
  mutation CreateWebsiteContentPreviewLink($id: Long!, $lang: WebsiteContentLangEnum!) {
    createWebsiteContentPreviewLink(id: $id, lang: $lang) {
      url
      expiresAt
    }
  }
`;

export const CREATE_WEBSITE_MEDIA_UPLOAD_URL = gql`
  mutation CreateWebsiteMediaUploadUrl($input: WebsiteMediaUploadInput!) {
    createWebsiteMediaUploadUrl(input: $input) {
      mediaId
      expiresAt
      original {
        objectKey
        url
        width
        format
      }
      variants {
        objectKey
        url
        width
        format
      }
    }
  }
`;

export const CONFIRM_WEBSITE_MEDIA_UPLOAD = gql`
  mutation ConfirmWebsiteMediaUpload($mediaId: Long!, $width: Int, $height: Int, $durationSeconds: Int) {
    confirmWebsiteMediaUpload(mediaId: $mediaId, width: $width, height: $height, durationSeconds: $durationSeconds) {
      id
      mediaType
      fileName
      mimeType
      sizeBytes
      width
      height
      durationSeconds
      url
      thumbnailUrl
      srcset {
        url
        width
      }
      referencedCount
      createdAt
    }
  }
`;

export const DELETE_WEBSITE_MEDIA = gql`
  mutation DeleteWebsiteMedia($id: Long!) {
    deleteWebsiteMedia(id: $id)
  }
`;

export const BATCH_DELETE_WEBSITE_MEDIA = gql`
  mutation BatchDeleteWebsiteMedia($ids: [Long!]!) {
    batchDeleteWebsiteMedia(ids: $ids) {
      succeededIds
      skipped {
        mediaId
        reason
        referencedCount
      }
    }
  }
`;
